import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Loading } from "../../../components/Loading/Loading";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { P220GetDataInfo, P220GetDataPicMap } from "../../../service/200/P220Service";
import { dataUserSession } from "../../../utilities/dataSession";
import P221 from "../221/P221";
import P222 from "../222/P222";
import P220Info from "./P220Info";
import P220List from "./P220List";
import P220Map from "./P220Map";
import P220PicList from "./P220PicList";
import P220Search from "./P220Search";

export default function P220() {
    const history = useHistory();
    const toast = useRef(null);

    const [errData, setErrData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dialog, setDialog] = useState({ dialog: false, action: "" });
    const [dialogAlert, setDialogAlert] = useState({ dialog: false, action: "" });

    const [searchData, setSearchData] = useState({
        contractNo: "",
        locationBegin: 0,
        locationEnd: 0,
        requestType: "A",
        routeNo: 0,
        routeName: "",
        userId: dataUserSession() ? dataUserSession().userId : "",
        ...(history.location.state ? history.location.state : ""),
    });

    const [data, setData] = useState({
        inTimeOrder: "",
        inspectEquipmentResult: "",
        inspectWorkerResult: "",
        operateDateBegin: "",
        operateDateEnd: "",
        overDueOrder: "",
        pendingOrder: "",
        requestQuantity: "",
        totalDeliver: "",
        totalOrder: "",
        warningLetter: "",
    });

    const [dataTable, setDataTable] = useState([]);
    const [dataPic, setDataPic] = useState([]);
    const [location, setLocation] = useState({ requestNo: "", requestLocation: "" });

    // new 12/01/2022
    const [userRole] = useState(dataUserSession() && dataUserSession().userRole ? dataUserSession().userRole : "");

    useEffect(() => {
        if (dataUserSession()) {
            //state from anoter pages
            if (!history.location.state) {
                // history.push("/208");
                if (userRole === "8" || userRole === "9") {
                    history.push("/350");
                } else {
                    history.push("/208");
                }
            }
        } else {
            history.push("/login");
        }
    }, []);

    // useEffect(() => {
    //     onP220GetDataInfo();
    // }, [searchData])

    useEffect(() => {
        onP220GetDataPicMap(location);
    }, [location]);

    const onP220GetDataInfo = (data) => {
        setLoading(true);
        P220GetDataInfo(data).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);

                    if (temp.length > 0) {
                        setData(temp[0]);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onP220GetDataPicMap = (data) => {
        let req = {
            requestNo: data.requestNo,
            userId: dataUserSession() ? dataUserSession().userId : "",
        };
        setLoading(true);
        P220GetDataPicMap(req).then(
            (res) => {
                setLoading(false);
                //console.log(res);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataPic(temp);

                    // if(temp.length > 0){
                    //     setData(temp[0])
                    // }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">ตรวจสอบการปฏิบัติงาน</h2>
                        <hr /> */}
                        <div className="p-grid  p-fluid">
                            {/* <div className="p-col-12 p-md-4"> */}
                            <div className="p-col-12 p-md-12">
                                <P220Search
                                    searchData={searchData}
                                    setSearchData={setSearchData}
                                    onSearch={onP220GetDataInfo}
                                    // dataList={dataGenList}
                                    // data = {searchData}
                                    // setData = {setSearchData}
                                    // setDataChart = {setSentChart}
                                />
                            </div>
                        </div>
                        {location && location.requestNo && location.requestNo !== "" ? (
                            <div className="p-grid  p-fluid">
                                <div className="p-col-12 p-md-4">
                                    <div className="card">
                                        <div className="p-grid  p-fluid">
                                            <P220Map data={searchData} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-col-12 p-md-8">
                                    <div className="p-col-12 p-md-12">
                                        <label htmlFor="inspectTime">บริเวณงาน</label>
                                        <InputText type="text" placeholder="บริเวณงาน" value={location.requestLocation} disabled maxLength="40" />
                                    </div>
                                    <div className="p-col-12 p-md-12">
                                        <P220PicList data={dataPic} />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}

                        {dataTable && dataTable.length > 0 ? (
                            <>
                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-lg-12">
                                        <P220Info data={data} setDialog={setDialog} setDialogAlert={setDialogAlert} />
                                    </div>
                                </div>

                                <div className="p-col-12">
                                    <P220List dataTable={dataTable} setLocation={setLocation} />
                                </div>
                            </>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>

            <P221 dialog={dialog} setDialog={setDialog} data={searchData} />

            <P222 dialog={dialogAlert} setDialog={setDialogAlert} data={searchData} />
        </>
    );
}
